import Popover from 'element-ui/lib/popover';
import clickoutside from 'element-ui/src/utils/clickoutside';
import PtIcon from '@patsnap-biz/icon';
import _ from 'lodash';
import { transformOptionField } from '../../../utils';
import OptionFieldPane from '../../OptionFieldPane.vue';
import '@patsnap-ui/icon/assets/solid/CloseMedium.svg';
export default {
    name: 'OptionEditor',
    directives: {
        clickoutside,
    },
    components: {
        ElPopover: Popover,
        OptionFieldPane,
        PtIcon,
    },
    inject: {
        controller: {
            from: 'controller',
        },
    },
    props: {
        field: {
            type: Object,
            required: true,
        },
        value: {
            type: Array,
            default: null,
        },
    },
    data() {
        return {
            isPopoverVisible: false,
            filter: '',
            value$: [],
            customCustomFieldEditorService: this.controller.getCustomCustomFieldEditorService(this.field),
        };
    },
    computed: {
        formattedValue() {
            return transformOptionField(this.value$, this.field.field_option_value);
        },
        isShowComments() {
            return this.customCustomFieldEditorService.isShowComments;
        },
    },
    watch: {
        value: {
            immediate: true,
            handler() {
                this.value$ = _.clone(this.value);
            },
        },
        value$() {
            this.updatePopper();
        },
        filter(words) {
            this.updatePopper();
            if (this.controller.customCustomFieldEditorComponent) {
                this.controller.getCustomCustomFieldEditorService(this.field).filterWords = words;
            }
        },
        isShowComments() {
            this.$nextTick(() => {
                this.updatePopper();
            });
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.isPopoverVisible = true;
            // @ts-ignore;
            this.focus();
        });
    },
    beforeDestroy() {
        if (this.isPopoverVisible) {
            this.onFinishEdit();
        }
    },
    methods: {
        updatePopper() {
            if (this.isPopoverVisible) {
                this.$nextTick(() => {
                    try {
                        // @ts-ignore;
                        this.$refs.EditorPopover.updatePopper();
                    }
                    catch (error) {
                        //
                    }
                });
            }
        },
        focus() {
            if (this.$refs.inputRef) {
                this.$refs.inputRef.focus();
            }
            if (this.$refs.inputContainer) {
                this.$refs.inputContainer.scrollTop = 9999;
            }
            this.updateCustomCustomFieldEditorValue();
        },
        updateCustomCustomFieldEditorValue() {
            if (this.controller.customCustomFieldEditorComponent) {
                this.controller.openCustomCustomFieldEditor({ field: this.field, value: this.value$ })
                    .onValueUpdate((val) => {
                    this.value$ = val;
                });
            }
        },
        onCheckChange() {
            this.filter = '';
            this.focus();
        },
        removeNode(optionId) {
            const index = _.indexOf(this.value$, optionId);
            if (index > -1) {
                this.value$.splice(index, 1);
                this.updateCustomCustomFieldEditorValue();
            }
        },
        onFinishEdit() {
            this.isPopoverVisible = false;
            this.$emit('endLabelingField');
            this.$emit('updateFieldValue', this.value$);
        },
    },
};
